import { ComponentProps, ReactNode, useContext } from 'react';
import clsx from 'clsx';
import { OpSwitch } from 'components/customAntd/DLS/OpSwitch/OpSwitch';
import { OpSkeleton } from 'components/customAntd/DLS/OpSkeleton/OpSkeleton';
import { OpFormContext } from '../../OpFormContext';
import { OpForm } from '../../OpForm';

import './OpFormSwitch.scss';

interface IOpFormSwitchProps
  extends Pick<ComponentProps<typeof OpForm.Item>, 'name' | 'tooltip'>,
    Omit<ComponentProps<typeof OpSwitch>, 'name' | 'tooltip'> {
  formItemClassName?: string;
  isLoading?: boolean;
  switchTooltip?: ReactNode;
}

export const OpFormSwitch = ({
  // Form Item props
  formItemClassName,
  name,
  tooltip,

  // For skeleton loading state
  isLoading,

  // Wrapped element props
  disabled,
  switchTooltip,

  ...elementProps
}: IOpFormSwitchProps) => {
  /** The Form is wrapped in a provider that passes the loading context
   *  to the component */
  const { isDataLoading, isReadOnly } = useContext(OpFormContext);

  return (
    <OpForm.Item
      className={clsx('op-form-switch', formItemClassName)}
      name={name}
      tooltip={tooltip}
      valuePropName="checked"
    >
      {isDataLoading || isLoading ? (
        <OpSkeleton.Button active size="small" shape="circle" />
      ) : (
        <OpSwitch
          disabled={isReadOnly || disabled}
          tooltip={switchTooltip}
          {...elementProps}
        />
      )}
    </OpForm.Item>
  );
};
